<template>
  <div class="head">
    <ul class="nav-l">
    </ul>
    <div><img src="../../assets/logo.png" height="142" width="518" style="margin-top: -30px"/></div>
    <ul class="nav-r">
    </ul>
    <AccountInfo></AccountInfo>
  </div>
</template>

<script>
import AccountInfo from '../layout/account-info';
export default {
  name: 'LayoutHeader',
  components:{
    AccountInfo
  },
  data () {
    return {
      nav: [
        {
          name: '驾驶舱',
          url: '/home'
        }, {
          name: '关于久鼎',
          url: '/palletabout'
        }, {
          name: '托盘总览',
          url: '/pallet'
        }, {
          name: '行业分析',
          url: '/palletanalysis'
        }
      ]
    }
  },
  created () {
  },
  methods: {
    hanle(url) {
      this.$router.push(url)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/layout/layout-header.vue